import { render, staticRenderFns } from "./DoubleDragListControl.vue?vue&type=template&id=e60f5300&lang=pug&"
import script from "./DoubleDragListControl.vue?vue&type=script&lang=js&"
export * from "./DoubleDragListControl.vue?vue&type=script&lang=js&"
import style0 from "./DoubleDragListControl.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports